import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../config/constants';
import { getSideBarFn } from '../../transactions/user/user';

const { SIDEBAR_ITEMS } = QUERY_KEYS;

const useSidebarItems = () => {
  return useQuery([SIDEBAR_ITEMS], getSideBarFn, {
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

export default useSidebarItems;
